import { createContext, useContext } from 'react';

export interface FilterFormMethods {
  resetToAppStore: () => void;
  resetToDefaults: () => void;
  applyFilters: () => void;
}

export const FilterFormMethodsContext = createContext<FilterFormMethods | null>(null);

export const useFilterFormMethods = () => {
  const context = useContext(FilterFormMethodsContext);
  if (!context) {
    throw new Error('useFilterFormMethods must be used within FilterFormController');
  }
  return context;
};
